export default[
    {
        path: '/cargohoraria/cadastro',
        name: 'cadastro de cargo horarias', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/cargohoraria/lista',
        name: 'lista de cargo horarias', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/cargohoraria/editar/:id',
        name: 'editar cargo horarias', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]